import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/metaPixel";

/** Fires Meta Pixel + CAPI PageView on every React Router path change. Must be
 *  rendered inside <BrowserRouter>. Deduplicates against React StrictMode's double-render
 *  and against successive same-URL renders. */
export default function MetaPageView() {
    const { pathname, search } = useLocation();
    const lastKey = useRef(null);
    useEffect(() => {
        const key = `${pathname}${search}`;
        if (lastKey.current === key) return;
        lastKey.current = key;
        trackPageView();
    }, [pathname, search]);
    return null;
}
